import React, { type FC, useEffect, useState } from 'react';

import { Alert } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import { unsubscribe } from 'client/api';
import { UnsubscribeState } from 'client/blocks/App/UnsubscribePage';
import { IndexLayout } from 'client/blocks-redesign/Layout/Layout';
import { PageLoader } from 'client/blocks-redesign/Loader/PageLoader';
import * as keyset from 'i18n/GeneralSettings';
import queryString from 'query-string';

import styles from './EmailPages.module.scss';

const t = i18n(keyset);

export const Unsubscribe: FC = () => {
    const [unsubscribeState, setUnsubscribeState] = useState<UnsubscribeState>('pending');

    useEffect(() => {
        const parsed = queryString.parse(location.search);

        if (!parsed.token) {
            return setUnsubscribeState('failure');
        }

        unsubscribe(parsed.token)
            .then(() => {
                setUnsubscribeState('success');
            })
            .catch((err) => {
                console.error(err);
                setUnsubscribeState('failure');
            });
    }, []);

    let content = <PageLoader />;

    if (unsubscribeState === 'success') {
        content = (
            <Alert
                message={<div className={styles.emailPages__content}>{t('unsubscribe-success')}</div>}
                theme="success"
            />
        );
    }

    if (unsubscribeState === 'failure') {
        content = (
            <Alert message={<div className={styles.emailPages__content}>{t('unsubscribe-fail')}</div>} theme="danger" />
        );
    }

    return (
        <IndexLayout>
            <div className={styles.emailPages__container}>{content}</div>;
        </IndexLayout>
    );
};
